export const EMAIL_NOTIFICATION_PREFERENCE_REQUEST =
  'EMAIL_NOTIFICATION_PREFERENCE_REQUEST'
export const EMAIL_NOTIFICATION_PREFERENCE_SUCCESS =
  'EMAIL_NOTIFICATION_PREFERENCE_SUCCESS'
export const EMAIL_NOTIFICATION_PREFERENCE_ERROR =
  'EMAIL_NOTIFICATION_PREFERENCE_ERROR'
export const EMAIL_NOTIFICATION_PREFERENCE_SET =
  'EMAIL_NOTIFICATION_PREFERENCE_SET'

export const EMAIL_NOTIFICATION_PREFERENCE_UPDATE_REQUEST =
  'EMAIL_NOTIFICATION_PREFERENCE_UPDATE_REQUEST'
export const EMAIL_NOTIFICATION_PREFERENCE_UPDATE_SUCCESS =
  'EMAIL_NOTIFICATION_PREFERENCE_UPDATE_SUCCESS'
export const EMAIL_NOTIFICATION_PREFERENCE_UPDATE_ERROR =
  'EMAIL_NOTIFICATION_PREFERENCE_UPDATE_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/user/email-preference.type.js